import React, { useState, useEffect, lazy } from 'react';
import { isEmpty as _isEmpty } from 'lodash-es';

const FusionCharts = lazy(() => import('components/FusionCharts/FusionCharts'));

const GraasHopperChart = props => {
  const { data } = props;
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return <>{isMounted && <FusionCharts type={data?.type} metadata={data?.dataSource} height={400} width='100%' />}</>;
};

export default GraasHopperChart;
